import { render, staticRenderFns } from "./ShowOrderDetails.vue?vue&type=template&id=63d395bc&scoped=true&"
import script from "./ShowOrderDetails.vue?vue&type=script&lang=js&"
export * from "./ShowOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShowOrderDetails.vue?vue&type=style&index=0&id=63d395bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d395bc",
  null
  
)

export default component.exports